import { Link } from 'react-router-dom';

type EmptyStateProps = {
  icon?: string;
  title: string;
  description: string;
  primaryLabel?: string;
  primaryTo?: string;
  onReset?: () => void;
  resetLabel?: string;
};

export default function EmptyState({
  icon = 'ri-search-eye-line',
  title,
  description,
  primaryLabel = '返回首页',
  primaryTo = '/',
  onReset,
  resetLabel = '重置筛选',
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-700 bg-background-900/60 px-6 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-950 text-primary-300">
        <i className={`${icon} text-2xl`} />
      </div>
      <h3 className="mt-5 text-base font-semibold text-foreground-100">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            {resetLabel}
          </button>
        )}
        <Link
          to={primaryTo}
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-700 px-4 py-2 text-sm text-foreground-300 transition-colors hover:border-accent-500 hover:text-accent-400"
        >
          {primaryLabel}
        </Link>
      </div>
    </div>
  );
}